import searchTermsColumn from './columns';

import ColumnsStorage from '@@/advertisement/common/ColumnsStorage';

const key = 'advertisement-search-terms-columns';

export default new ColumnsStorage({
  columns: searchTermsColumn.dynamic,
  keyToStoreWith: key,
});
